export const environment = {
  apiUrl: 'https://api.quik-ai.com',
  markdownEditorUrl: 'https://editor.chat.quik-ai.com/editor',
  connectorsUrl: 'https://connectors.quik-ai.com',
  envName: 'PROD',
};
